import g from '#core/global';
import load from '#core/load';


const card_$ = '.solution-card';
const bg_$ = '.solution-card__bg';
const text_$ = '.solution-card__text';
const abstract_$ = '.solution-card__abstract';
const bg_x_prop = '--bg-x';
const bg_y_prop = '--bg-y';
const reveal_prop = '--reveal-y';
const ready_attr = 'data-solution-card-ready';

let observer = null;


const module = {

	/**
	 * Init module
	 */
	init() {
		if (load.ran('solution-card')) return false;

		load.content(() => {
			assign_elements();
		});
		load.all(() => {
			assign_elements();
		});
	},

};

export default module;
module.init();


/**
 * Randomize each background crop once and watch each abstract
 * @return {boolean}
 */
function assign_elements() {
	const $cards = document.querySelectorAll(card_$);
	if (!$cards.length) return false;

	$cards.forEach($card => {
		if ($card.getAttribute(ready_attr) === g.true_s) return;

		$card.setAttribute(ready_attr, g.true_s);
		set_background($card);
		observe_abstract($card);
	});

	return true;
}


/**
 * Watch the abstract so the reveal distance is remeasured whenever its height
 * changes — a width change, a font swap, or an edit to its own spacing. The
 * observer reports once on observing, which is the initial measurement.
 * @param {element} $card
 * @return {boolean}
 */
function observe_abstract($card) {
	const $abstract = $card.querySelector(abstract_$);
	if (!$abstract) return false;

	if (!observer) observer = new ResizeObserver(set_reveals);

	// Watch the border box: the reveal distance includes the abstract's own
	// padding, and a content box would not report a change to it
	observer.observe($abstract, { box: 'border-box' });

	return true;
}


/**
 * Remeasure the reported cards. The base styles transition `translate` on every
 * div, so the offsets are applied with transitions suppressed inline: without
 * that the text slides into its collapsed position on load, and again whenever
 * an abstract is remeasured.
 * @param {array} entries
 * @return {boolean}
 */
function set_reveals(entries) {
	const $cards = entries
		.map(entry => entry.target.closest(card_$))
		.filter($card => $card)
	;
	if (!$cards.length) return false;

	const $texts = $cards
		.map($card => $card.querySelector(text_$))
		.filter($text => $text)
	;

	$texts.forEach($text => {
		$text.style.transition = 'none';
	});

	$cards.forEach($card => {
		set_reveal($card);
	});

	// Force a reflow so the offsets are established before transitions resume
	document.body.offsetHeight;

	$texts.forEach($text => {
		$text.style.transition = '';
	});

	return true;
}


/**
 * Publish the abstract's height as the distance the text block is pushed down
 * while collapsed. The abstract keeps that height in the layout at all times,
 * so the card is already tall enough for the text it reveals and its height
 * never changes on hover.
 * @param {element} $card
 * @return {boolean}
 */
function set_reveal($card) {
	const $abstract = $card.querySelector(abstract_$);
	if (!$abstract) return false;

	// Read the rect rather than the computed height, which excludes padding
	const height = $abstract.getBoundingClientRect().height;
	$card.style.setProperty(reveal_prop, `${height}px`);

	return true;
}


/**
 * Randomize the background crop. The image covers the card at any height, so
 * the crop is a percentage and never needs remeasuring.
 * @param {element} $card
 * @return {boolean}
 */
function set_background($card) {
	const $bg = $card.querySelector(bg_$);
	if (!$bg) return false;

	$bg.style.setProperty(bg_x_prop, `${Math.round(Math.random() * 100)}%`);
	$bg.style.setProperty(bg_y_prop, `${Math.round(Math.random() * 100)}%`);

	return true;
}
